import { toRaw } from 'vue';
/**
 * Reproduce los logs del servidor en la consola del navegador.
 * @param {Array<Object>} logs - El array de objetos de log del servidor.
 * Cada objeto debe tener la forma { type: string, args: any[] }.
 */
export function replayLogs(logs) {
  if (!Array.isArray(logs)) {
    console.error('Se esperaba un array de logs.');
    return;
  }

  console.group('Inicio de la reproducción de logs del servidor');

  logs.forEach((logEntry, index) => {
    const { type, args } = toRaw(logEntry);

    // Verificar que el tipo de log es una función válida de la consola
    if (typeof console[type] === 'function') {
      // Usar el operador de propagación para pasar los argumentos
      // tal como se recibieron. Esto mantiene el formato de objetos, etc.
      console[type](...args);
    } else {
      console.warn(`Tipo de log desconocido en la entrada ${index}:`, type, args);
    }
  });

  console.groupEnd();
}
